import { formatTableDate } from './formatTableDate'

/**
 * Displays the actual date if it exists, otherwise displays the estimated date with an "~" prefix.
 * Returns null if neither date exists.
 */
export function displayActualOrEstimatedDate(
  actualDate?: Date | null,
  estimatedDate?: Date | null
): string | null {
  if (actualDate) {
    return formatTableDate(actualDate)
  } else if (estimatedDate) {
    return `~ ${formatTableDate(estimatedDate)}`
  } else {
    return null
  }
}
